import { render } from "./DocumentReportFieldSelectionQuality.vue?vue&type=template&id=3c8eb5f2&scoped=true&ts=true"
import script from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"
export * from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"

import "./DocumentReportFieldSelectionQuality.vue?vue&type=style&index=0&id=3c8eb5f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8eb5f2"]])

export default __exports__